import { render, staticRenderFns } from "./CustomersClasses.vue?vue&type=template&id=6b481262&"
import script from "./CustomersClasses.vue?vue&type=script&lang=js&"
export * from "./CustomersClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports